import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { disableContextMenu } from 'disable-context-menu';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "bootstrap-icons/font/bootstrap-icons.min.css"

require('@/config/axios');
disableContextMenu();

createApp(App).use(i18n).use(router).mount('#app')
